'use client';

import { useEffect, useState } from 'react';

/**
 * Whether this browser can run the NAM WASM player.
 *
 * The engine (neural-amp-modeler-wasm) builds its graph with the unprefixed
 * `AudioContext` constructor and an `AudioWorklet` — both WebKit 14.1+. Old
 * Catalina-era webviews (Safari 13–14.0) have neither, so plugin webviews on
 * those systems would throw the moment a user taps play. Players check this
 * and fall back to their disabled state instead.
 *
 * Two-pass on purpose: SSR and the hydration render return `true` so markup
 * matches, then the effect flips unsupported browsers to `false` after mount.
 */
export function useAudioEngineSupport(): boolean {
  const [supported, setSupported] = useState(true);

  useEffect(() => {
    if (
      typeof window.AudioWorkletNode === 'undefined' ||
      typeof window.AudioContext === 'undefined'
    ) {
      setSupported(false);
    }
  }, []);

  return supported;
}
